import GlobalTabs from "modules/swiftboard/components/GlobalTabs";

// Page frame for every swiftboard page that is a strip of tabs over one tab's
// content (Live Projects, User Management, Central Directories, ...).
//
// Usage:
//   <TabPageLayout tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange}>
//     {activeTab === 0 && <Clients />}
//     {activeTab === 1 && <Admin />}
//   </TabPageLayout>
//
// Props:
//   tabs, activeTab, onTabChange   passed to GlobalTabs (onTabChange gets (index, tab))
//   background                     page background utility; match the tab pages'
//                                  own root background (default "bg-surface_alt")
//
// Layout: h-full (never h-screen / min-h-screen) so the page fits MainLayout's
// fixed-height <main> under the header instead of being clipped. The tab page
// fills the remaining height; most scroll their own table, and the content
// area scrolls for pages that just grow with their content.
export default function TabPageLayout({
  tabs,
  activeTab,
  onTabChange,
  background = "bg-surface_alt",
  children,
}) {
  return (
    <div className={`h-full flex flex-col overflow-hidden ${background}`}>
      <div className="max-w-[100rem] mx-auto w-full h-full flex flex-col gap-4 py-3">
        {/* Same card frame as the toolbar and table below. pt-1 centers the
            labels (the tab has more padding under the text for its underline);
            !border-b-0 drops the tab strip's own bottom line, which would
            double up with the card's border. */}
        <div className="flex-shrink-0 bg-surface border border-border rounded-lg shadow-sm overflow-hidden pt-1">
          <GlobalTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
            size="md"
            variant="underlined"
            className="!border-b-0"
          />
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
